import jwtDecode from "jwt-decode";
import { TableToken } from "../types";

export const isPayOnlyPartyToken = (tableToken: string) => {
    const { partytype } = jwtDecode<TableToken>(tableToken);
    return partytype === "payonly";
};
